import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { Link } from "react-router-dom";
import { BiSolidDonateHeart } from "react-icons/bi";

const fiturData = [
  {
    title: "Galang Dana Peduli Sumatera",
    description: "Jangan Biarkan Sumatera Berjuang Sendirian. Saatnya kita bergerak. Kirimkan bantuan terbaik Anda untuk pangan dan obat-obatan bagi warga terdampak. Setiap rupiah sangat berarti..",
    image: "/images/gdutama1.jpg",
    cards: [{ image: "/images/gd2.jpeg" }, { image: "/images/gd3.jpg" }, { image: "/images/gd1.jpeg" }],
  },
  // {
  //   title: "Program Bantuan Pangan",
  //   description: "Jangan Biarkan Sumatera Berjuang Sendirian. Saatnya kita bergerak. Kirimkan bantuan terbaik Anda untuk pangan dan obat-obatan bagi warga terdampak. Setiap rupiah sangat berarti..",
  //   image: "/images/bk5.jpg",
  //   cards: [{ image: "/images/bk-program.jpg" }, { image: "/images/isu1a.jpg" }, { image: "/images/bk-program2.jpg" }],
  // },
];

const Fitur = () => {
  const IconGalangDana = BiSolidDonateHeart as React.FC<React.SVGProps<SVGSVGElement>>;
  return (
    <section className="bg-dark pt-16 pb-10">
      <div className="relative px-5 xl:px-10">
        {/* Title */}
        <div className="flex gap-5 items-center mb-10">
          <h1 className="lg:text-[28px]  font-semibold text-[22px]  text-primary font-bilbo w-[400px]">GALANG DANA</h1>
          <div className="w-full h-[3px] bg-white/20 "></div>
        </div>

        {/* Swiper Content */}
        <Swiper modules={[Navigation, Autoplay]} autoplay={{ delay: 3000, disableOnInteraction: false }}>
          {fiturData.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
                {/* Left Image */}
                <div>
                  <img src={item.image} alt={item.title} className="w-full h-72 lg:h-96 rounded-2xl object-cover shadow-lg" />
                </div>

                {/* Right Content */}
                <div>
                  <h3 className="text-2xl md:text-3xl font-bold text-primary mb-4 hidden lg:block">{item.title}</h3>

                  <p className="text-gray-500 text-base leading-relaxed mb-5 text-justify">{item.description}</p>
                  <Link to={"https://belaskasih.com/account/campaign/new"} target="_blank">
                    <div className="border border-white text-white px-7 py-2 rounded-lg mb-5 flex justify-center items-center gap-2">
                      Galang Dana Sekarang <IconGalangDana />
                    </div>
                  </Link>

                  <div className="flex  gap-2 lg:gap-5">
                    {item.cards.map((card, idx) => (
                      <div key={idx} className="relative rounded-xl overflow-hidden shadow-md cursor-pointer group flex-1">
                        <img src={card.image} alt="tujuan" className="w-full h-28 lg:h-40 object-cover" />
                        <div className="absolute inset-0 bg-gradient-to-t from-orange-600/60 to-transparent transition-opacity group-hover:opacity-80" />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Fitur;
